import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';
import CustomGameSettingsView from './customGameSettingsView.jsx';
import BotLevel from './botLevel.jsx';


class LobbyView extends React.Component {

    clickStart() {
        this.props.clickStart();
    }

    clickKick(id) {
        this.props.clickKick(id);
    }

    genStartButton() {
        if (this.props.isAdmin)
        {
            return (
                <button onClick={this.clickStart.bind(this)} class="button1">Start Game</button>
            );
        }
    }

    genJoinLink() {
        return (
            <div>
                Join Link: <br/>
                { this.props.baseURL + "/join/" + this.props.joinCode }
            </div>
        );
    }

    genX(index) {

        if (this.props.isAdmin && index > 0)
        {
            var player = this.props.players[index];

            return (
                <span class="x" onClick={this.clickKick.bind(this, player.sessionId)}>
                    X
                </span>
            );
        }
    }

    genPlayer(index) {
        var player = this.props.players[index];

        return (
            <td>
                <div class="name">
                    { player.name }
                    { this.genX(index) }
                </div>
            </td>
        );
    }

    clickAddBot() {
        this.props.addBot();   
    }

    genBot() {
        
        if (this.props.players.length < 8) {
            return (
                <td>
                    <div class="addBot" onClick={this.clickAddBot.bind(this)}>
                        + Add Bot
                    </div>
                </td>
            );
        }
    }

    setBotLevel(lvl) {
        console.log("LobbyView:: setBotLevel @" + lvl);
        this.props.setBotLevel(lvl);
    }

    genBotLevel() {
        if (this.props.numBots > 0 && this.props.isAdmin) {
            return (
                <span class="customGameBotLevel">
                    Bot Level: <BotLevel value={this.props.botLevel} setValue={this.setBotLevel.bind(this)}/> <br/><br/>
                </span>
            );
        }
    }

	render() {

        var cellNum = 0;
        let rows = [];
        var cell = [];

        for (var i = 0; i < this.props.players.length + 1; i++)
        {   
            if (i < this.props.players.length)
                cell.push(this.genPlayer(i));
            else {
                if (this.props.isAdmin)
                    cell.push(this.genBot());
                else
                    break;
            }

            cellNum++;
            if (cellNum > 1)
            {
                cellNum = 0;

                rows.push(<tr>{cell}</tr>);
                cell = [];
            }
        }

        if (cell.length > 0)
            rows.push(<tr>{cell}</tr>);


        rows.push(<tr>
            <td>
                { this.genBotLevel() }
            </td>    
            <td>
                { 
                    this.props.isAdmin &&
                    <span class="customGameSettings" onClick={this.props.clickSettings}>
                        { this.props.isAdmin && ">> Edit Game Settings" }
                        { !this.props.isAdmin && "View Game Settings" }
                    </span>
                }
                { this.genStartButton() }
            </td>    
        </tr>);

        return (
            <div class="main" id="main">
                <canvas id="backCanvas" class="backCanvas"></canvas>
                <Header clickBack={this.props.clickBack} name={this.props.roomName}/>

                <div class="middle" id="nickname">
                    Join code: {this.props.joinCode}
                    
                    <table>
                        <tbody>
                            { rows }
                        </tbody>
                    </table>

                    { this.genJoinLink() }
                    
                </div>
                { this.props.settingsOverlayOpen && <CustomGameSettingsView resetToDefault={this.props.resetToDefault} reRender={this.props.reRender} clickSettings={this.props.clickSettings} customGameSettings={this.props.customGameSettings}/> }
            </div>
        );
	}
}

LobbyView.propTypes = {
  clickStart: PropTypes.func,
  clickKick: PropTypes.func,
  clickBack: PropTypes.func,

  addBot: PropTypes.func,
  setBotLevel: PropTypes.func,
  numBots: PropTypes.number,
  botLevel: PropTypes.number,
  settingsOverlayOpen: PropTypes.bool,
  clickSettings: PropTypes.func,
  reRender: PropTypes.func,
  resetToDefault: PropTypes.func,

  roomName: PropTypes.string,
  joinCode: PropTypes.string,
  baseURL: PropTypes.string,
  isAdmin: PropTypes.bool,
  players: PropTypes.array,
};


export default LobbyView;